import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, addDoc, onSnapshot, query, doc, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { FaPlus, FaPencilAlt, FaTrash, FaSearch, FaTimes, FaUserPlus, FaUserEdit, FaFilePdf, FaSpinner, FaChild, FaExclamationTriangle } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import Modal from 'react-modal';
import { motion, AnimatePresence } from 'framer-motion';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ClientesPDF from './components/ClientesPDF'; 

const customModalStyles = { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', border: 'none', background: 'transparent', width: '90%', maxWidth: '500px', padding: '0' }, overlay: { backgroundColor: 'rgba(35, 37, 89, 0.75)', zIndex: 1050 }};

// --- COMPONENTE BOTON PDF ---
const BotonDescargaPDF = ({ clientes }) => {
    const [isReady, setIsReady] = useState(false);
    return (
        <div onMouseEnter={() => setIsReady(true)} onClick={() => setIsReady(true)}>
            {isReady ? (
                <PDFDownloadLink document={<ClientesPDF clientes={clientes} />} fileName={`BD_Familias_Kokimiko_${new Date().toISOString().split('T')[0]}.pdf`} style={{ textDecoration: 'none' }}>
                    {({ loading }) => (
                        <motion.button whileTap={{ scale: 0.95 }} className={`flex items-center gap-2 text-sm font-bold h-9 px-3 rounded-md shadow-sm transition-colors uppercase tracking-wider ${loading ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-kokimiko-naranja hover:opacity-80 text-white'}`} disabled={loading}>
                            {loading ? <FaSpinner className="animate-spin" /> : <FaFilePdf />}
                            <span className="hidden sm:inline">{loading ? 'Preparando...' : 'Exportar BD'}</span>
                        </motion.button>
                    )}
                </PDFDownloadLink>
            ) : (
                <motion.button whileTap={{ scale: 0.95 }} className="flex items-center gap-2 bg-kokimiko-naranja text-white text-sm font-bold h-9 px-3 rounded-md shadow-sm hover:opacity-80 transition-colors uppercase tracking-wider">
                    <FaFilePdf /> <span className="hidden sm:inline">Exportar BD</span>
                </motion.button>
            )}
        </div>
    );
};

// --- MODAL PARA REGISTRAR NIÑOS ---
function NinoFormModal({ onSave, onClose, initialData = {} }) {
    const [nombreNino, setNombreNino] = useState(initialData.nombre || '');
    const [edad, setEdad] = useState(initialData.edad || '');
    const [cumpleanos, setCumpleanos] = useState(initialData.cumpleanos || '');
    const [alergias, setAlergias] = useState(initialData.alergias || '');
    
    const handleSubmit = (e) => { 
        e.preventDefault(); 
        if (!nombreNino) return toast.error("El nombre del niño es obligatorio."); 
        onSave({ nombre: nombreNino, edad: edad, cumpleanos: cumpleanos, alergias: alergias }); 
        onClose(); 
    };
    
    const inputStyle = "mt-1 block w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-kokimiko-teal focus:border-kokimiko-teal";
    const labelStyle = "block text-xs font-black text-kokimiko-texto uppercase tracking-widest";

    return (
        <motion.form initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.2 }} onSubmit={handleSubmit} className="bg-white p-6 rounded-[2rem] shadow-2xl border border-gray-100">
            <h3 className="text-xl font-black text-kokimiko-texto mb-5 flex items-center gap-2 uppercase">
                <FaChild className="text-kokimiko-teal" /> 
                {initialData.nombre ? 'Editar Datos del Niño' : 'Registrar Nuevo Niño'}
            </h3>
            <div className="space-y-4">
                <div><label className={labelStyle}>Nombre del Niño(a)</label><input type="text" value={nombreNino} onChange={e => setNombreNino(e.target.value)} placeholder="Ej: Santiago" required className={inputStyle} /></div>
                <div className="grid grid-cols-2 gap-4">
                    <div><label className={labelStyle}>Edad</label><input type="text" value={edad} onChange={e => setEdad(e.target.value)} placeholder="Ej: 5 años" className={inputStyle} /></div>
                    <div><label className={labelStyle}>Cumpleaños</label><input type="text" value={cumpleanos} onChange={e => setCumpleanos(e.target.value)} placeholder="Ej: 12 de Mayo" className={inputStyle} /></div>
                </div>
                <div><label className={`${labelStyle} flex items-center gap-1`}><FaExclamationTriangle className="text-kokimiko-naranja" /> Alergias / Notas Médicas</label><input type="text" value={alergias} onChange={e => setAlergias(e.target.value)} placeholder="Ej: Alérgico al maní, intolerante a la lactosa..." className={`${inputStyle} border-orange-100 bg-orange-50 focus:ring-kokimiko-naranja`} /></div>
            </div>
            <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                <motion.button whileTap={{ scale: 0.95 }} type="button" onClick={onClose} className="bg-gray-100 text-kokimiko-texto text-sm font-bold h-10 px-5 rounded-xl shadow-sm hover:bg-gray-200 transition-colors uppercase tracking-widest">Cancelar</motion.button>
                <motion.button whileTap={{ scale: 0.95 }} type="submit" className="bg-kokimiko-teal text-white text-sm font-bold h-10 px-5 rounded-xl shadow-md hover:opacity-80 transition-all flex items-center justify-center gap-2 uppercase tracking-widest"><FaPlus /> Guardar</motion.button>
            </div>
        </motion.form>
    );
}

function ClientesView() {
    const [clientes, setClientes] = useState([]);
    const [cargando, setCargando] = useState(true);
    
    // --- ESTADOS DEL FORMULARIO KOKIMIKO ---
    const [nombreRepresentante, setNombreRepresentante] = useState('');
    const [dni, setDni] = useState('');
    const [telefono, setTelefono] = useState('');
    const [email, setEmail] = useState('');
    const [direccion, setDireccion] = useState('');
    
    const [editingClientId, setEditingClientId] = useState(null);
    const [ninos, setNinos] = useState([]);
    const [isNinoModalOpen, setIsNinoModalOpen] = useState(false);
    const [editingNinoIndex, setEditingNinoIndex] = useState(null);
    
    // Búsqueda
    const [inputValue, setInputValue] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [searchPerformed, setSearchPerformed] = useState(false);
    
    const inputStyle = "mt-1 block w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-kokimiko-teal focus:border-kokimiko-teal";
    const labelStyle = "block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1";
    
    useEffect(() => { 
        const q = query(collection(db, 'clientes')); // Mantenemos la colección 'clientes' por compatibilidad
        const unsubscribe = onSnapshot(q, (snapshot) => { 
            const clientesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })); 
            clientesData.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0)); 
            setClientes(clientesData); 
            setCargando(false); 
        }); 
        return () => unsubscribe(); 
    }, []);
    
    const resetForm = () => { 
        setNombreRepresentante(''); 
        setDni(''); 
        setTelefono(''); 
        setEmail(''); 
        setDireccion(''); 
        setNinos([]); 
        setEditingClientId(null); 
    };
    
    const handleEditClick = (cliente) => { 
        setEditingClientId(cliente.id); 
        setNombreRepresentante(cliente.nombreRepresentante || cliente.name || ''); 
        setDni(cliente.dni || cliente.nif || ''); 
        setTelefono(cliente.telefono || ''); 
        setEmail(cliente.email || ''); 
        setDireccion(cliente.direccion || ''); 
        setNinos(cliente.ninos || cliente.personasContacto || []); 
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
    };
    
    const handleSaveCliente = async (e) => { 
        e.preventDefault(); 
        if (!nombreRepresentante) return toast.error('El nombre del representante es obligatorio.'); 
        
        const clientData = { 
            nombreRepresentante, 
            dni, 
            telefono, 
            email, 
            direccion, 
            ninos, 
            status: 'Activo',
            // Mantenemos campos legacy sincronizados temporalmente por si hay dependencias
            name: nombreRepresentante,
            nif: dni,
            personasContacto: ninos 
        }; 
        
        const toastId = toast.loading(editingClientId ? 'Actualizando Familia...' : 'Registrando Familia...'); 
        try { 
            if (editingClientId) { 
                const clientDocRef = doc(db, 'clientes', editingClientId); 
                await updateDoc(clientDocRef, { ...clientData, updatedAt: serverTimestamp() }); 
                toast.success('¡Familia actualizada!', { id: toastId }); 
            } else { 
                await addDoc(collection(db, 'clientes'), { ...clientData, createdAt: serverTimestamp() }); 
                toast.success('¡Familia registrada con éxito!', { id: toastId }); 
            } 
            resetForm(); 
        } catch (error) { 
            console.error("Error al guardar cliente: ", error); 
            toast.error('No se pudo guardar la familia.', { id: toastId }); 
        } 
    };
    
    const handleDeleteClient = async (clientId) => { if (window.confirm("¿Estás seguro de que quieres eliminar esta familia del sistema?")) { try { await deleteDoc(doc(db, 'clientes', clientId)); toast.success('Familia eliminada.'); } catch (error) { toast.error('Error al eliminar.'); } } };
    const handleSaveNino = (ninoData) => { if (editingNinoIndex !== null) { setNinos(ninos.map((c, index) => index === editingNinoIndex ? ninoData : c)); } else { setNinos([...ninos, ninoData]); } setEditingNinoIndex(null); };
    const handleOpenNinoModal = (index = null) => { setEditingNinoIndex(index); setIsNinoModalOpen(true); };
    const handleDeleteNino = (indexToDelete) => { setNinos(ninos.filter((_, index) => index !== indexToDelete)); };
    const handleSearch = () => { setSearchTerm(inputValue); setSearchPerformed(true); };
    const clearSearch = () => { setInputValue(''); setSearchTerm(''); setSearchPerformed(false); };
    
    const filteredClientes = clientes.filter(c => { 
        const searchTermLower = searchTerm.toLowerCase(); 
        const inName = (c.nombreRepresentante || c.name || '').toLowerCase().includes(searchTermLower); 
        const inDni = (c.dni || c.nif || '').toLowerCase().includes(searchTermLower); 
        const inPhone = (c.telefono || '').toLowerCase().includes(searchTermLower); 
        const inEmail = (c.email || '').toLowerCase().includes(searchTermLower);
        const inKids = (c.ninos || c.personasContacto)?.some(p => (p.nombre || '').toLowerCase().includes(searchTermLower)); 
        return inName || inDni || inPhone || inEmail || inKids; 
    });

    const tableRowVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.05, duration: 0.2 } }),
        exit: { opacity: 0, x: -50, transition: { duration: 0.1 } }
    };

    return (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="h-full flex flex-col p-4 md:p-8 gap-6 font-sans">
            <Toaster position="top-center" />
            <div className="flex justify-between items-center bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100">
                <h1 className="text-2xl font-black text-kokimiko-texto uppercase tracking-widest flex items-center gap-3">
                    <div className="p-3 bg-kokimiko-teal rounded-xl text-white"><FaUserPlus /></div>
                    Registro de Familias
                </h1>
                {clientes.length > 0 && <BotonDescargaPDF clientes={searchPerformed ? filteredClientes : clientes} />}
            </div>

            <motion.div layout initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} className="bg-white p-6 rounded-[2.5rem] shadow-sm border border-gray-100">
                 <form onSubmit={handleSaveCliente}>
                    <h4 className="font-black text-kokimiko-texto uppercase text-sm mb-4 tracking-widest border-b pb-2">Datos del Representante</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                        <div className="lg:col-span-2"><label className={labelStyle}>Nombre y Apellido</label><input type="text" value={nombreRepresentante} onChange={(e) => setNombreRepresentante(e.target.value)} placeholder="Ej: María Pérez" required className={inputStyle}/></div>
                        <div><label className={labelStyle}>DNI / NIE</label><input type="text" value={dni} onChange={(e) => setDni(e.target.value)} placeholder="Opcional" className={inputStyle}/></div>
                        <div><label className={labelStyle}>Teléfono Principal</label><input type="tel" value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="Ej: 600 123 456" required className={inputStyle}/></div>
                        <div><label className={labelStyle}>Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="correo@ejemplo.com" className={inputStyle}/></div>
                    </div>
                    
                    <div className="mt-4">
                        <label className={labelStyle}>Dirección (Opcional)</label>
                        <input type="text" value={direccion} onChange={(e) => setDireccion(e.target.value)} placeholder="Calle, número, ciudad..." className={inputStyle}/>
                    </div>
                    
                    <div className="mt-8 border-t border-gray-100 pt-6">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
                            <h4 className="font-black text-kokimiko-texto uppercase text-sm tracking-widest">Niños Registrados</h4>
                            <motion.button whileTap={{scale: 0.95}} type="button" onClick={() => handleOpenNinoModal()} className="w-full sm:w-auto flex items-center justify-center gap-2 bg-kokimiko-verde text-white text-xs font-black px-4 py-2 rounded-xl hover:opacity-80 transition-all shadow-md uppercase tracking-widest"><FaPlus /> Añadir Niño</motion.button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                            <AnimatePresence>
                                {ninos.map((nino, index) => (
                                    <motion.div key={index} initial={{opacity: 0, scale: 0.9}} animate={{opacity: 1, scale: 1}} exit={{opacity: 0, scale: 0.9}} transition={{ duration: 0.2 }} layout className="flex flex-col bg-kokimiko-teal/5 p-4 rounded-2xl border border-kokimiko-teal/20 relative group">
                                        <div className="flex justify-between items-start mb-2">
                                            <p className="font-black text-kokimiko-texto text-lg">{nino.nombre}</p>
                                            <div className="flex gap-2">
                                                <motion.button whileTap={{scale: 0.9}} type="button" onClick={() => handleOpenNinoModal(index)} className="text-gray-400 hover:text-kokimiko-teal p-1"><FaUserEdit size={16}/></motion.button>
                                                <motion.button whileTap={{scale: 0.9}} type="button" onClick={() => handleDeleteNino(index)} className="text-gray-400 hover:text-kokimiko-naranja p-1"><FaTrash size={16}/></motion.button>
                                            </div>
                                        </div>
                                        <div className="flex gap-4 text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">
                                            <span>{nino.edad || 'Edad N/A'}</span>
                                            <span>{nino.cumpleanos ? `🎁 ${nino.cumpleanos}` : 'Cumple N/A'}</span>
                                        </div>
                                        {nino.alergias && (
                                            <p className="text-[11px] font-bold text-kokimiko-naranja bg-kokimiko-naranja/10 px-2 py-1 rounded-lg mt-auto flex items-start gap-1">
                                                <FaExclamationTriangle className="mt-0.5 shrink-0" /> {nino.alergias}
                                            </p>
                                        )}
                                    </motion.div>
                                ))}
                                {ninos.length === 0 && (
                                    <div className="col-span-full p-6 text-center border-2 border-dashed border-gray-200 rounded-2xl text-gray-400 font-bold text-sm">
                                        No hay niños registrados en esta familia.
                                    </div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                    
                    <div className="flex items-center justify-end gap-3 mt-8 border-t border-gray-100 pt-6">
                        {editingClientId && (<motion.button whileTap={{scale: 0.95}} type="button" onClick={resetForm} className="bg-gray-100 text-kokimiko-texto text-sm font-bold h-10 px-6 rounded-xl shadow-sm hover:bg-gray-200 uppercase tracking-widest">Cancelar</motion.button>)}
                        <motion.button whileTap={{scale: 0.95}} type="submit" className="bg-kokimiko-teal text-white text-sm font-black h-10 px-8 rounded-xl shadow-lg hover:opacity-80 flex items-center justify-center gap-2 uppercase tracking-widest"><FaPlus />{editingClientId ? 'Actualizar Ficha' : 'Guardar Familia'}</motion.button>
                    </div>
                </form>
            </motion.div>
            
            <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col sm:flex-row items-center gap-3">
                <div className="relative flex-grow w-full">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none"><FaSearch className="text-gray-400" /></span>
                    <input type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()} placeholder="Buscar por nombre, teléfono, niño..." className="block w-full pl-10 pr-4 py-3 text-sm font-bold text-gray-700 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-kokimiko-texto"/>
                </div>
                <motion.button whileTap={{scale: 0.95}} onClick={handleSearch} className="w-full sm:w-auto flex justify-center items-center gap-2 bg-kokimiko-texto text-white text-sm font-black h-11 px-6 rounded-xl shadow-md hover:opacity-80 uppercase tracking-widest"><FaSearch /> <span className="sm:hidden md:inline">Buscar</span></motion.button>
                <motion.button whileTap={{scale: 0.95}} onClick={clearSearch} className="w-full sm:w-auto flex justify-center items-center gap-2 bg-gray-200 text-gray-700 text-sm font-black h-11 px-6 rounded-xl shadow-sm hover:bg-gray-300 uppercase tracking-widest"><FaTimes /> <span className="sm:hidden md:inline">Limpiar</span></motion.button>
            </div>

            {searchPerformed ? (
                <motion.div layout className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden flex-grow">
                    <table className="min-w-full leading-normal">
                        <thead>
                            <tr>
                                <th className="px-6 py-4 bg-gray-50 text-left text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100">Familia / Representante</th>
                                <th className="px-6 py-4 bg-gray-50 text-left text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100">Contacto</th>
                                <th className="px-6 py-4 bg-gray-50 text-left text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100">Niños Registrados</th>
                                <th className="px-6 py-4 bg-gray-50 border-b border-gray-100"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <AnimatePresence>
                                {cargando ? (<tr><td colSpan="4" className="text-center py-8 font-bold text-gray-400 animate-pulse">Buscando Familias...</td></tr>) : ( filteredClientes.length > 0 ? ( filteredClientes.map((cliente, i) => ( 
                                    <motion.tr 
                                        key={cliente.id} 
                                        custom={i} 
                                        variants={tableRowVariants} 
                                        initial="hidden"
                                        animate="visible"
                                        exit="exit"
                                        layout="position"
                                        className="hover:bg-kokimiko-teal/5 transition-colors border-b border-gray-50"
                                    >
                                        <td className="px-6 py-4 text-sm"><p className="text-kokimiko-texto font-black text-base">{cliente.nombreRepresentante || cliente.name}</p><p className="text-gray-400 font-bold text-xs">{cliente.dni || cliente.nif || 'Sin DNI'}</p></td>
                                        <td className="px-6 py-4 text-sm"><p className="text-gray-700 font-bold">{cliente.telefono || 'Sin teléfono'}</p><p className="text-gray-400 text-xs">{cliente.email || 'Sin correo'}</p></td>
                                        <td className="px-6 py-4 text-sm">
                                            {(cliente.ninos || cliente.personasContacto)?.length > 0 ? (
                                                <div className="flex flex-wrap gap-1">
                                                    {(cliente.ninos || cliente.personasContacto).map((n, idx) => (
                                                        <span key={idx} className="bg-kokimiko-teal/10 text-kokimiko-teal text-[10px] font-black px-2 py-1 rounded-md uppercase">{n.nombre}</span>
                                                    ))}
                                                </div>
                                            ) : (
                                                <span className="text-gray-400 text-xs italic">Sin niños</span>
                                            )}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-right">
                                            <div className="flex justify-end gap-3">
                                                <motion.button whileTap={{ scale: 0.9 }} onClick={() => handleEditClick(cliente)} className="text-gray-400 hover:text-kokimiko-teal bg-white p-2 rounded-lg shadow-sm border border-gray-100"><FaPencilAlt size={14}/></motion.button>
                                                <motion.button whileTap={{ scale: 0.9 }} onClick={() => handleDeleteClient(cliente.id)} className="text-gray-400 hover:text-kokimiko-naranja bg-white p-2 rounded-lg shadow-sm border border-gray-100"><FaTrash size={14}/></motion.button>
                                            </div>
                                        </td>
                                    </motion.tr>
                                )) ) : (<tr><td colSpan="4" className="text-center py-8 text-sm font-bold text-gray-400">No se encontraron familias.</td></tr>) )}
                            </AnimatePresence>
                        </tbody>
                    </table>
                </motion.div>
            ) : ( <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex-grow flex items-center justify-center bg-white rounded-[2rem] shadow-sm border border-gray-100"><p className="text-gray-400 text-sm font-bold text-center p-8 border-2 border-dashed border-gray-200 rounded-2xl">Usa la barra de búsqueda para encontrar la ficha de una familia.</p></motion.div> )}

            <AnimatePresence>
                {isNinoModalOpen && (
                    <Modal isOpen={true} onRequestClose={() => setIsNinoModalOpen(false)} style={customModalStyles} ariaHideApp={false}>
                        <NinoFormModal 
                            onSave={handleSaveNino} 
                            onClose={() => setIsNinoModalOpen(false)} 
                            initialData={editingNinoIndex !== null ? ninos[editingNinoIndex] : {}}
                        />
                    </Modal>
                )}
            </AnimatePresence>
        </motion.div>
    );
}

export default ClientesView;